import { checkGoogleAuthenticator } from "@/apis/user";
import { passwordkit } from "@/components/PasswordKit";
import { useUserInfoStore } from "@/stores/userInfo";
import { Toast } from "antd-mobile";

export const useGlobalVerify = () => {
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);

  return [
    async () => {
      Toast.show("请输入资金密码");
      return await passwordkit();
    },
    async () => {
      if (userInfo && userInfo.isGoogleAuthenticator) {
        Toast.show("请输入Google安全码");

        const code = await passwordkit();
        if (!code) return false;

        const { ok, msg } = await checkGoogleAuthenticator({
          safeCode: code,
        });

        if (!ok) {
          Toast.show({
            icon: "fail",
            content: msg,
          });
        }
        return ok;
      } else {
        return true;
      }
    },
  ];
};
